import { useMemo } from "react";
import {
  useRefinementList,
  type UseRefinementListProps,
} from "react-instantsearch";

export const useFacet = (props: UseRefinementListProps) => {
  const { items, refine } = useRefinementList(props);

  const facetValueToCountMap = useMemo(() => {
    return new Map(items.map(({ value, count }) => [value, count]));
  }, [items]);

  const resetFacet = () => {
    const refinedItems = items.filter(({ isRefined }) => isRefined);

    for (const item of refinedItems) {
      refine(item.value);
    }
  };

  return { items, refine, facetValueToCountMap, resetFacet };
};
